import React from "react";
import { Box, Typography } from "@mui/material";
import * as styles from "../styles/Home.js";

const CardInvertir = ({ title, text, icon }) => {
  return (
    <Box sx={styles.styleCardContainer}>
      <div>
        <Typography sx={styles.styleCardTitle}>{title}</Typography>
        <Box sx={{ display: { xs: "none", sm: "block" } }}>
          <img src={icon} alt={title} style={styles.styleCardIcon} />
        </Box>
        <Typography sx={styles.styleCardText}>{text}</Typography>
      </div>
    </Box>
  );
};

export default CardInvertir;
